import { Tooltip, Chip, Box, Typography } from "@mui/material";
import { getPreviewMessage, truncateText } from "../../utils/templatePreview";

export default function TemplatePreviewCell({ row }) {
  const preview = getPreviewMessage(
    row.channel_type,
    row.message_json
  );

  const safePreview =
    typeof preview === "object" ? preview?.content : preview;

  if (!safePreview) return "—";

  return (
    <Tooltip
      placement="top-start"
      enterDelay={300}
      leaveDelay={150}
      disableInteractive
      title={
        <Box
          sx={{
            backgroundColor: "#fff",
            color: "#000",
            px: 1.5,
            py: 1,
            borderRadius: 1, 
            maxWidth: 360,
            maxHeight: 220,
            overflowY: "auto",
            boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.4,
            }}
          >
            {safePreview}
          </Typography>
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "transparent",
            p: 0,
          },
        },
      }}
    >
      <Chip
        variant="outlined"
        label={truncateText(safePreview, 30)}
        sx={{
          maxWidth: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          border: "none",
          fontSize: {
            xs: "11px",
            sm: "12px",
            lg: "14px",
            xl: "16px",
          },
          cursor: "default",
        }}
      />
    </Tooltip>
  );
}
